/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./message.defs.js";
export { main as default } from "./message.defs.js";
